import loadMonetateModule from './modules/Monetate.module';
import loadCookieConsentModule from './modules/CookieConsent.module';
const loadMonetateRootModule = () => ({
    hasRouter: false,
    modules: [loadMonetateModule(), loadCookieConsentModule()],
});
export default loadMonetateRootModule;
